const GlobalReducer = (state, action) => {
  switch (action.type) {
    case "SET_GLOBAL_DATE":
      return {
        ...state,
        globalDate: action.payload,
      };
    case "SET_GLOBAL_CURRENT_FY":
      return { ...state, globalCurrentFY: action.payload };
    case "SET_GLOBAL_ACTIVE_REPORT_PAGE":
      return { ...state, activeReportPage: action.payload };
    case "SET_USER_DATA": {
      return { ...state, userData: action.payload };
    }
    case "SET_TOKEN_LOGIN_START": {
      return { ...state, tokenLoginLoading: true };
    }
    case "SET_GLOBAL_ACTIVE_INSERTION_PAGE": {
      return { ...state, activeInsertionPage: action.payload };
    }
    case "SET_TOKEN_LOGIN_DATA": {
      return {
        ...state,
        tokenLoginLoading: false,
        userData: action.payload.userData,
      };
    }
    case "SET_TOKEN_LOGIN_ERROR": {
      return {
        ...state,
        tokenLoginLoading: false,
        error: action.payload.error,
      };
    }
    case "SET_TOKEN_LOGIN_FINISH": {
      return { ...state, tokenLoginLoading: false };
    }
    default:
      throw new Error(`No Matching "${action.type}" - action type`);
  }
};

export default GlobalReducer;
